module.exports = __webpack_public_path__ + "static/media/logo-whitee.9997c39b.png";